import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center m-5">
            <h1>404! This Page is not Found</h1>
        </div>
    );
};

export default NotFound;